import React, { useState, useMemo } from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from './Logo';
import { getModules } from '../../../navigation/modules.repository';

const { Sider } = Layout;


const SidebarComponent = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modules, setModules] = useState([]);

  const getActiveKey = (modulesToSearch = modules) => {
    const currentPath = location.pathname;
    
    for (const module of modulesToSearch) {
      if (module.subMenu) {
        const matchingSubMenu = module.subMenu.find(sub => sub.path === currentPath);
        if (matchingSubMenu) {
          return matchingSubMenu.key;
        }
      }

      if (module.path && module.path === currentPath) {
        return module.key;
      }
    }

    return 'dashboard';
  };

  const getOpenKey = (modulesToSearch = modules) => {
    const currentPath = location.pathname;
    
    for (const module of modulesToSearch) {
      if (module.subMenu) {
        const matchingSubMenu = module.subMenu.find(sub => sub.path === currentPath);
        if (matchingSubMenu) {
          return module.key;
        }
      }
    }

    return null;
  };

  const [activeKey, setActiveKey] = useState(getActiveKey());
  const [openKeys, setOpenKeys] = useState(() => {
    const openKey = getOpenKey();
    return openKey ? [openKey] : [];
  });

  React.useEffect(() => {
    getModules().then((loadedModules) => {
      setModules(loadedModules);

      setActiveKey(getActiveKey(loadedModules));
      const openKey = getOpenKey(loadedModules);
      setOpenKeys(openKey ? [openKey] : []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleMenuClick = (e) => {
    const { key } = e;
    
    for (const module of modules) {
      if (module.subMenu) {
        const subMenuItem = module.subMenu.find(sub => sub.key === key);
        if (subMenuItem) {
          navigate(subMenuItem.path);
          setActiveKey(key);
          return;
        }
      }
      
      if (!module.subMenu && module.key === key && module.path) {
        navigate(module.path);
        setActiveKey(key);
        return;
      }
    }
    
    // if (key === 'logout') {
    //   console.log('Logout clicked');
    // }
    
    setActiveKey(key);
  };

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    
    if (latestOpenKey) {
      setOpenKeys([latestOpenKey]);
    } else {
      setOpenKeys([]);
    }
  };

  const menuItems = useMemo(() => {
    const items = [];
    
    modules.forEach((m) => {
      if (m.subMenu && m.subMenu.length > 0) {
        items.push({
          key: m.key,
          icon: <i className={`fa-solid ${m.icon}`} />,
          label: m.label,
          children: m.subMenu.map((subItem) => ({
            key: subItem.key,
            label: subItem.label,
          })),
        });
      } else {
        items.push({
          key: m.key,
          icon: <i className={`fa-solid ${m.icon}`} />,
          label: m.label,
        });
      }
      
      if (m.divider) {
        items.push({
          type: 'divider',
          style: { borderBottom: '1px solid #BA955E', margin: '8px 10%', },
        });
      }
    });
    
    return items;
  }, [modules]);

  return (
    <Sider
      className="futpremia-sider"
      style={{
        zIndex: 10000,
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        boxShadow: '2px 0 6px rgba(0,21,41,.35)',
        background: '#ff0000',
      }}
      width={240}
      collapsible
      collapsed={collapsed}
      trigger={null}
    >
      <Logo collapsed={collapsed} />
      <Menu
        className="futpremia-menu"
        mode="inline"
        selectedKeys={[activeKey]}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        onClick={handleMenuClick}
        items={menuItems}
      />

      <button
        className="futpremia-toggle"
        onClick={() => setCollapsed(!collapsed)}
        aria-label="Toggle sidebar"
      >
        <i className={`fa-solid ${collapsed ? 'fa-angle-right' : 'fa-angle-left'}`}></i>
      </button>
    </Sider>
  );
};

export default SidebarComponent;
